import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardAnalyticsEditRoute: InvariantJiraRoute = {
	name: 'dashboard-analytics-edit',
	path: '/jira/dashboards/:dashboardId(\\w+-\\w+-\\w+-\\w+-\\w+)/edit',
	exact: true,
};
